import Response from "../models/response";
import { ACCESS_TOKEN } from "@/utils/constants";

export default class Util {
  static authHeaders(): Record<string, any> {
    return { Authorization: `${localStorage.getItem(ACCESS_TOKEN)}` };
  }

  static apiUrl(path: string): string {
    return `${process.env.VUE_APP_API_URL}${path}`;
  }

  static handleResponse(resp: any): Promise<any> {
    if (!resp.data) {
      throw resp;
    }

    const response = Response.fromJSON(resp.data);
    return response.status.messages[0].responseCode == "VS-200"
      ? Promise.resolve(response)
      : Promise.reject(response);
  }
}
